import { render, staticRenderFns } from "./PasswordChangeReminderBanner.vue?vue&type=template&id=47889169&"
import script from "./PasswordChangeReminderBanner.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeReminderBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports